import { View, Text, Linking, StyleSheet } from "react-native";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../common/general/CustomButton/CustomButton";

function GoogleConsentModal({ visible, companionName, onClose, onConfirm }) {
  const { isMedium } = useResponsiveScreen();

  const onTermsPress = () => {
    Linking.openURL("https://primer.net/Terms-of-Service");
  };

  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Google Calendar Consent">
      <CustomText
        text="consent_request"
        size="l"
        interpolation={{ companionName }} // Pass companionName here
      />
      <CustomSpacing type="vertical" size="l" />

      <Text style={styles.text}>
        Please review our{" "}
        <Text role="link" style={[styles.text, styles.link]} onPress={onTermsPress}>
          Terms of Service
        </Text>{" "}
        before proceeding.
      </Text>
      <CustomSpacing type="vertical" size="l" />

      <View style={styles.buttonContainer}>
        <CustomButton
          text="Cancel"
          onPress={onClose}
          styleType="primary"
          style={[styles.cancelButton, styles.noShadow]}
        />
        <CustomButton
          aria-label="Give consent"
          text="Give Consent"
          onPress={onConfirm}
          styleType="primary"
          style={styles.noShadow}
        />
      </View>
    </CustomModal>
  );
}

const styles = StyleSheet.create({
  text: {
    color: "#474747",
    fontSize: 18,
  },
  link: {
    color: "blue",
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
  },
  noShadow: {
    shadowColor: "transparent",
    elevation: 0,
  },
  cancelButton: {
    backgroundColor: "grey",
  },
});

export default GoogleConsentModal;
